import { useEffect, useRef, useState } from "react";
import ContactSection from "./contact-section";
import ContentSection from "./content-section";
import SelectSection from "./select-section";
import PhuBaoAnGiaProduct from "../product/PhuBaoAnGiaProduct";
import Form from "../form-submit/form";
import Footer from "../../Layouts/footer/Footer";
import '../../Style/font_responsive.css';
import FinishSection from "../finish/finish-section";
import CircularProgress from "@mui/material/CircularProgress";
import { isEmptyObj, isNullOrEmpty } from "../../Services/service";
import FinishPaymentSection from "../finish/finish-payment-section";
import { nextStep } from "../../Services/api-service";
import ErrorBoundary from "../../Components/error-boundary/ErrorBoundary";

function Home ({objectDto, setObjectDto}) {
    const [isLoading, setIsLoading] = useState(false);
    const [imgFront, setImgFront] = useState(null);
    const [imgBack, setImgBack] = useState(null);
    const targetDivRef = useRef(null);
    const [confirm, setConfirm] = useState(false);
    useEffect(()=>{
        if(isNullOrEmpty(objectDto) || isNullOrEmpty(objectDto.step)){
            window.scrollTo(0,0);
            return setObjectDto(prev => ({...prev, step: 0}));
        }
        if((objectDto?.step === 0 && isNullOrEmpty(objectDto?.sessionId)) || objectDto?.step === -2 || objectDto?.gender === null){
            setIsLoading(true);
            if(objectDto?.step !== -2)
                nextStep(objectDto, setObjectDto, setIsLoading);
            else
                setIsLoading(false);
            return;
        }
        if(!isNullOrEmpty(objectDto.step) && objectDto.step !== 4){
            if(!isNullOrEmpty(localStorage.getItem("###"))) localStorage.removeItem("###")
        }
        if(objectDto.step !== 6) {
            localStorage.removeItem("####");
        }
        if(objectDto.step === 1 && objectDto.productList !== null && objectDto.productList.length > 0){
            setConfirm(true);
        }
    },[objectDto]);
    useEffect(()=>{
        if(isNullOrEmpty(objectDto) || isNullOrEmpty(objectDto.step) || objectDto.step !== 4)
            if(isLoading) 
                document.body.style.overflow = "hidden";
            else 
                document.body.style.overflow = "auto";
        if(!isLoading && objectDto !== null && objectDto.step === 1 && objectDto.productList.length > 0 && (objectDto.discount > 0 || isNullOrEmpty(objectDto.promotionCode))){
            const targetY = targetDivRef.current.getBoundingClientRect().top + window.pageYOffset;
            smoothScrollTo(targetY, 500);
        }
    },[isLoading]);
    const smoothScrollTo = (targetY, duration = 800) => {
        const startY = window.pageYOffset;
        const distance = targetY - startY;
        let startTime = null;

        const easeInOutCubic = (t) =>
            t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2;

        const animation = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            window.scrollTo(0, startY + distance * easeInOutCubic(progress));

            if (elapsed < duration) {
            requestAnimationFrame(animation);
            }
        };
        requestAnimationFrame(animation);
    };
    return(
            <ErrorBoundary>  
            { 
                isLoading && 
                    <div className="circular-progress-main">
                        <CircularProgress variant="indeterminate" className="progress-circle" size={100} thickness={4} />
                    </div>
                    
            }
            {
                (isNullOrEmpty(objectDto) || isEmptyObj(objectDto)) || (!isNullOrEmpty(objectDto) && objectDto.step === -1)
                ? 
                    <> 
                        <ContentSection />
                        <SelectSection objectDto={objectDto} setObjectDto={setObjectDto} />
                        <ContactSection />
                    </>
                :
                    (
                        objectDto.step === 0 || objectDto.step === 1 
                            ?
                                <PhuBaoAnGiaProduct confirm={confirm} setConfirm={setConfirm} targetDivRef={targetDivRef} objectDto={objectDto} setIsLoading={setIsLoading} setObjectDto={setObjectDto} />
                                : 
                                objectDto.step === -2 ? 
                                
                                    <FinishSection objectDto={objectDto} setIsLoading={setIsLoading} setObjectDto={setObjectDto}/>
                                    :
                                    objectDto.step < 8 
                                        ?
                                        <Form setImgBack={setImgBack} setImgFront={setImgFront} imgBack={imgBack} imgFront={imgFront} objectDto={objectDto} setIsLoading={setIsLoading} setObjectDto={setObjectDto}/> 
                                        : 
                                        <FinishPaymentSection objectDto={objectDto} setIsLoading={setIsLoading} setObjectDto={setObjectDto}/>
                    )
            }
            <Footer />
        </ErrorBoundary>
    );
}

export default Home;